module.exports = __webpack_public_path__ + "static/img/full2.782a4a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/full2.png
// module id = SWNk
// module chunks = 24